module.exports = emirates;